<app-modal
  [title]="title"
  maxWidth="400px"
  [compact]="true"
>
  <ng-template>
    <p [innerHTML]="text"></p>
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary text-uppercase"
        (click)="okClick()"
      >
        {{ 'Ok' | trans:'alert-modal/buttons.Ok' }}
      </button>
    </div>
  </ng-container>
</app-modal>
